import React, { Dispatch, useCallback, useEffect, useState } from 'react';

import { EditUserReports } from './EditUserReports';
import { deleteReport, getReports } from 'data/report';
import { Dropdown } from 'components/reusable/Dropdown';
import { Report } from 'types/reports';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import { replace } from 'hooks/reportsSlice';

export function UserReports({
  styles,
  addNotification,
  confirmAction,
  displayError,
}: {
  styles: any;
  addNotification: any;
  confirmAction: Dispatch<any>;
  displayError: Dispatch<any>;
}) {
  const dispatch = useAppDispatch();
  const reports = useAppSelector((state) => state.reports);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const updateReports = useCallback(async () => {
    console.log('----------- GETTING USER REPORTS DATA -----------');
    getReports().then((data) => {
      dispatch(replace({ reports: data }));
    });
  }, [dispatch]);

  const actualDeleteRoute = useCallback(
    (id: string) => {
      return deleteReport(id)
        .then(updateReports)
        .catch(() =>
          displayError('An error has occurred please try again later.'),
        );
    },
    [updateReports, displayError],
  );

  const confirmDelete = useCallback(
    (report: Report) => {
      confirmAction({
        title: 'Delete User Report',
        name: 'this report',
        delete: () => actualDeleteRoute(report.id),
      });
    },
    [confirmAction, actualDeleteRoute],
  );

  function handleReport(approve: boolean, report: Report) {
    if (approve) {
      actualDeleteRoute(report.id);
      addNotification(report);
    } else {
      confirmDelete(report);
    }
  }

  useEffect(() => {
    updateReports();
  }, [updateReports]);

  return (
    <Dropdown
      title={'User Reports'}
      isCollapsed={isCollapsed}
      setCollapsed={() => setIsCollapsed(!isCollapsed)}
    >
      {reports && (
        <EditUserReports styles={styles} handleReport={handleReport} />
      )}
    </Dropdown>
  );
}
